import { SuccessIcon } from '@p2p/assets/svg';
import { Button, Typography } from '@p2p/components';
import { usePaymentTemplate } from '@p2p/entities/templates';
import { useCallback, useEffect } from 'react';

import { MainContainer } from '../MainContainer';
import { useTimer } from '../Timer';
import { TransferHead } from '../TransferHead';
import styles from './PaymentSuccess.module.scss';
import { PaymentSuccessProps } from './PaymentSuccess.types';

const COUNT_SECONDS = 5;

export const PaymentSuccess = ({ order }: PaymentSuccessProps) => {
  const { setActiveIndex } = usePaymentTemplate();
  const handleSuccess = useCallback(() => {
    window.location.replace(order?.merchant_success_page);
  }, [order?.merchant_success_page]);
  const { second, locateWordSecond } = useTimer({ time: COUNT_SECONDS, onTimeout: handleSuccess });

  useEffect(() => {
    setActiveIndex(3);
  }, [setActiveIndex]);

  return (
    <MainContainer maxWidth="460px" className={styles.container}>
      <TransferHead order={order} />
      <div className={styles.content}>
        <SuccessIcon className={styles.icon} />
        <Typography variant="h1" color="heading" className={styles.title}>
          Оплата прошла успешно!
        </Typography>
        <Typography variant="text-l-medium" color="description">
          Мы перенаправим Вас на сайт через {second} {locateWordSecond}
        </Typography>
      </div>
      <Button onClick={handleSuccess}>Вернуться на сайт</Button>
    </MainContainer>
  );
};
